import ErrorComponent from '@/components/ErrorComponent/ErrorComponent';

interface SentryFallbackProps {
  error: unknown; // <- change ici unknown pour matcher Sentry
  componentStack: string;
  resetError(): void;
  eventId?: string;
}

export default function SentryFallback({ error, resetError }: SentryFallbackProps) {
  const normalizedError = error instanceof Error ? error : new Error(String(error));

  return <ErrorComponent error={normalizedError} reset={resetError} />;
}
